var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404-page"},[_c('Page404')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }